const EMBEDDED_BUILD_ID = process.env.REACT_APP_BUILD_ID;

let checkStarted = false;

/**
 * If the user loaded an old JS bundle, /build-version.json will report a newer
 * buildId than the one baked into this bundle — prompt a reload.
 */
export function checkAppVersionOnLoad() {
  if (typeof window === "undefined" || checkStarted) {
    return;
  }
  checkStarted = true;

  if (!EMBEDDED_BUILD_ID || EMBEDDED_BUILD_ID === "dev") {
    return;
  }

  (async () => {
    try {
      const response = await fetch(`/build-version.json?t=${Date.now()}`, {
        cache: "no-store",
      });
      if (!response.ok) {
        return;
      }
      const { buildId } = await response.json();
      if (!buildId || buildId === EMBEDDED_BUILD_ID) {
        return;
      }

      const shouldReload = window.confirm(
        "A new version of MCVerse is available. Reload now to get the latest features?"
      );
      if (shouldReload) {
        window.location.reload();
      }
    } catch {
      // Offline or missing file — ignore.
    }
  })();
}
